import { createFileRoute } from "@tanstack/react-router";
import { Profile } from "@/pages/client/Profile";

export const Route = createFileRoute("/_angemeldet/profil")({
	component: Profile,
});
